import { useState, forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

// Campo password con icona per mostrare/nascondere il testo (stile shadcn Input).
export const PasswordInput = forwardRef(({ className = "", ...props }, ref) => {
  const [show, setShow] = useState(false);
  const baseTid = props["data-testid"] || "password";
  return (
    <div className="relative">
      <Input ref={ref} {...props} type={show ? "text" : "password"} className={`pr-10 ${className}`} />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Nascondi password" : "Mostra password"}
        title={show ? "Nascondi password" : "Mostra password"}
        data-testid={`${baseTid}-toggle`}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground p-0.5 rounded"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";
